<template>
  <Layout>
    <div
      class="page-title-box d-flex align-items-center justify-content-between"
    >
      <h4 class="mb-0">Create Link Account</h4>
      <span @click="$router.go(-1)" style="cursor: pointer; color: grey"
        >Back</span
      >
    </div>
    <div class="row" id="notification">
      <div class="col-12">
        <div class="card">
          <div class="card-body">

            <h4>Linked Account Details</h4>

            <b-form autocomplete="off" @submit.prevent="submitForm">


              <!-- BASIC INFO -->
              <h5 class="mt-3">Basic Information</h5>
              <b-row>
                <b-col cols="6">
                  <!-- <b-form-group label="Email *">
                    <b-form-input v-model="form8.email"></b-form-input>
                  </b-form-group> -->
                  <b-form-group>
                    <label for="email"
                      >Email <span style="color: red">*</span></label
                    >
                    <b-form-input
                      v-model="form8.email"
                      :class="{ 'is-invalid': $v.form8.email.$error || getBackendError('email') }"
                    />
                    <div v-if="$v.form8.email.$error" class="invalid-feedback">
                      <div v-if="!$v.form8.email.required">Email is required.</div>
                      <div v-if="!$v.form8.email.email">Enter a valid email address.</div>
                    </div>
                    <div v-if="getBackendError('email')" class="invalid-feedback">
                      {{ getBackendError('email') }}
                    </div>
                    
                  </b-form-group>

                </b-col>

                <b-col cols="6">
                  <!-- <b-form-group label="Phone *">
                    <b-form-input v-model="form8.phone"></b-form-input>
                  </b-form-group> -->
                  <b-form-group>
                    <label for="phone"
                      >Phone <span style="color: red">*</span></label
                    >
                    <b-form-input
                      v-model="form8.phone"
                      @keypress="allowOnlyNumbers"
                      :maxlength="10"
                      :class="{ 'is-invalid': $v.form8.phone.$error || getBackendError('phone') }"
                    />
                    <div v-if="$v.form8.phone.$error" class="invalid-feedback">
                      <div v-if="!$v.form8.phone.required">Phone number is required.</div>
                      <div v-if="!$v.form8.phone.numeric">Phone must be numeric.</div>
                      <div v-if="!$v.form8.phone.minLength">Must be at least 8 digits.</div>
                      <div v-if="!$v.form8.phone.maxLength">Cannot exceed 15 digits.</div>
                    </div>
                    <div v-if="getBackendError('phone')" class="invalid-feedback">
                      {{ getBackendError('phone') }}
                    </div>
                    
                  </b-form-group>
                </b-col>

                <b-col cols="6">
                  <!-- <b-form-group label="Legal Business Name *">
                    <b-form-input v-model="form8.legal_business_name"></b-form-input>
                  </b-form-group> -->
                  <b-form-group>
                    <label for="business_name"
                      >Legal Business Name <span style="color: red">*</span></label
                    >
                    <b-form-input
                      v-model="form8.legal_business_name"
                      :class="{ 'is-invalid': $v.form8.legal_business_name.$error || getBackendError('legal_business_name') }"
                    />
                    <div v-if="$v.form8.legal_business_name.$error" class="invalid-feedback">
                      <div v-if="!$v.form8.legal_business_name.required">Required.</div>
                      <div v-if="!$v.form8.legal_business_name.minLength">Minimum 4 characters.</div>
                      <div v-if="!$v.form8.legal_business_name.maxLength">Maximum 200 characters.</div>
                    </div>
                    <div v-if="getBackendError('legal_business_name')" class="invalid-feedback">
                      {{ getBackendError('legal_business_name') }}
                    </div>
                    
                  </b-form-group>

                </b-col>

                <b-col cols="6">
                  <!-- <b-form-group label="Customer Facing Business Name">
                    <b-form-input v-model="form8.customer_facing_business_name"></b-form-input>
                  </b-form-group> -->
                  <!-- <b-form-group>
                    <label for="facing_business_name"
                      >Customer Facing Business Name </label
                    >
                    <b-form-input
                      v-model="form8.customer_facing_business_name"
                      :class="{ 'is-invalid': $v.form8.customer_facing_business_name.$error || getBackendError('customer_facing_business_name') }"
                    />
                    <div v-if="$v.form8.customer_facing_business_name.$error" class="invalid-feedback">
                      <div v-if="!$v.form8.customer_facing_business_name.minLength">Minimum 1 character.</div>
                      <div v-if="!$v.form8.customer_facing_business_name.maxLength">Maximum 255 characters.</div>
                    </div>
                    <div v-if="getBackendError('customer_facing_business_name')" class="invalid-feedback">
                      {{ getBackendError('customer_facing_business_name') }}
                    </div>
                    
                  </b-form-group> -->
                  <b-form-group>
                    <label for="Full Name"
                      >Full Name <span style="color: red">*</span></label
                    >
                    <b-form-input @keypress="allowOnlyText" v-model="form8.contact_name"
                      :class="{ 'is-invalid': $v.form8.contact_name.$error || getBackendError('contact_name') }"
                    ></b-form-input>
                    <div v-if="$v.form8.contact_name.$error" class="invalid-feedback">
                      <div v-if="!$v.form8.contact_name.required">Full Name is required.</div>
                    </div>
                    <div v-if="getBackendError('contact_name')" class="invalid-feedback">
                      {{ getBackendError('contact_name') }}
                    </div>
                    
                  </b-form-group>

                </b-col>

                <!-- <b-col cols="6">
                  <b-form-group label="Full Name">
                    <b-form-input v-model="form8.contact_name"
                      :class="{ 'is-invalid': $v.form8.contact_name.$error || getBackendError('contact_name') }"
                    ></b-form-input>
                    <div v-if="$v.form8.contact_name.$error" class="invalid-feedback">
                      <div v-if="!$v.form8.contact_name.required">Full Name is required.</div>
                    </div>
                    <div v-if="getBackendError('contact_name')" class="invalid-feedback">
                      {{ getBackendError('contact_name') }}
                    </div>
                    
                  </b-form-group>
                </b-col> -->
              </b-row>

              <!-- PROFILE -->
              <h5 class="mt-4">Business Profile</h5>
              <b-row>
                <b-col cols="6">
                  <b-form-group>
                    <label for="Category"
                      >Category <span style="color: red">*</span></label
                    >
                    <b-form-select
                      v-model="form8.category"
                      :options="categories"
                      :class="{ 'is-invalid': $v.form8.category.$error || getBackendError('category') }"
                    ></b-form-select>

                    <div v-if="$v.form8.category.$error" class="invalid-feedback">
                      Category is required.
                    </div>
                    <div v-if="getBackendError('category')" class="invalid-feedback">
                      {{ getBackendError('category') }}
                    </div>
                    
                  </b-form-group>
                </b-col>


                <b-col cols="6">
                  <b-form-group>
                    <label for="Subcategory"
                      >Subcategory <span style="color: red">*</span></label
                    >
                    <b-form-select
                      v-model="form8.subcategory"
                      :options="filteredSubcategories"
                      :disabled="!form8.category"
                      :class="{ 'is-invalid': $v.form8.subcategory.$error || getBackendError('subcategory') }"
                    ></b-form-select>

                    <div v-if="$v.form8.subcategory.$error" class="invalid-feedback">
                      Subcategory is required.
                    </div>
                    <div v-if="getBackendError('subcategory')" class="invalid-feedback">
                      {{ getBackendError('subcategory') }}
                    </div>
                    
                  </b-form-group>
                </b-col>


                <!-- <b-col cols="6">
                  <b-form-group label="Business Model">
                    <b-form-textarea v-model="form8.business_model"></b-form-textarea>
                  </b-form-group>
                </b-col> -->

                <b-col cols="6">
                  <b-form-group>
                    <label for="business_type">
                      Business Type <span style="color: red">*</span>
                    </label>

                    <b-form-select
                      v-model="form8.business_type"
                      :options="businessTypes"
                      :class="{ 'is-invalid': $v.form8.business_type.$error || getBackendError('business_type') }"
                    ></b-form-select>

                    <div v-if="$v.form8.business_type.$error" class="invalid-feedback">
                      Business Type is required.
                    </div>
                    <div v-if="getBackendError('business_type')" class="invalid-feedback">
                      {{ getBackendError('business_type') }}
                    </div>
                    
                  </b-form-group>
                </b-col>

              </b-row>

              <!-- REGISTERED ADDRESS -->
              <h5 class="mt-4">Registered Address <span style="color: red">*</span></h5>
              <b-row>
                <b-col cols="6">
                  <!-- <b-form-group label="Street 1">
                    <b-form-input v-model="form8.street1"></b-form-input>
                  </b-form-group> -->
                  <b-form-group>
                    <label for="Street 1"
                      >Street 1 <span style="color: red">*</span></label
                    >
                    <b-form-input
                      v-model="form8.street1"
                      :class="{ 'is-invalid': $v.form8.street1.$error || getBackendError('street1') }"
                    />
                    <div v-if="$v.form8.street1.$error" class="invalid-feedback">
                      Maximum 100 characters allowed.
                    </div>
                    <div v-if="getBackendError('street1')" class="invalid-feedback">
                      {{ getBackendError('street1') }}
                    </div>
                    
                  </b-form-group>

                </b-col>

                <b-col cols="6">
                  <!-- <b-form-group label="Street 2">
                    <b-form-input v-model="form8.street2"></b-form-input>
                  </b-form-group> -->
                  <b-form-group>
                    <label for="Street 2"
                      >Street 2 <span style="color: red">*</span></label
                    >
                    <b-form-input
                      v-model="form8.street2"
                      :class="{ 'is-invalid': $v.form8.street2.$error || getBackendError('street2') }"
                    />
                    <div v-if="$v.form8.street2.$error" class="invalid-feedback">
                      Maximum 100 characters allowed.
                    </div>
                    <div v-if="getBackendError('street2')" class="invalid-feedback">
                      {{ getBackendError('street2') }}
                    </div>
                    
                  </b-form-group>

                </b-col>

                <b-col cols="4">
                  <!-- <b-form-group label="City">
                    <b-form-input v-model="form8.city"></b-form-input>
                  </b-form-group> -->
                  <b-form-group>
                    <label for="City"
                      >City <span style="color: red">*</span></label
                    >
                    <b-form-input
                      @keypress="allowOnlyText"
                      v-model="form8.city"
                      :class="{ 'is-invalid': $v.form8.city.$error || getBackendError('city') }"
                    />
                    <div v-if="$v.form8.city.$error" class="invalid-feedback">
                      <div v-if="!$v.form8.city.required">City is required.</div>
                      <div v-if="!$v.form8.city.maxLength">Maximum 100 characters allowed.</div>
                      <div v-if="!$v.form8.city.onlyText">Only alphabets are allowed.</div>
                    </div>
                    <div v-if="getBackendError('city')" class="invalid-feedback">
                      {{ getBackendError('city') }}
                    </div>
                    
                  </b-form-group>

                </b-col>

                <b-col cols="4">
                  <!-- <b-form-group label="State">
                    <b-form-input v-model="form8.state"></b-form-input>
                  </b-form-group> -->
                  <b-form-group>
                    <label for="State"
                      >State <span style="color: red">*</span></label
                    >
                    <b-form-input
                      @keypress="allowOnlyText"
                      v-model="form8.state"
                      :class="{ 'is-invalid': $v.form8.state.$error || getBackendError('state') }"
                    />
                    <div v-if="$v.form8.state.$error" class="invalid-feedback">
                      <div v-if="!$v.form8.state.minLength">Minimum 2 characters.</div>
                      <div v-if="!$v.form8.state.maxLength">Maximum 32 characters.</div>
                    </div>
                    <div v-if="getBackendError('state')" class="invalid-feedback">
                      {{ getBackendError('state') }}
                    </div>
                    
                  </b-form-group>

                </b-col>

                <b-col cols="4">
                  <!-- <b-form-group label="Postal Code (6 digits)">
                    <b-form-input v-model="form8.postal_code"></b-form-input>
                  </b-form-group> -->
                  <b-form-group>
                    <label for="Postal Code (6 digits)"
                      >Postal Code (6 digits) <span style="color: red">*</span></label
                    >
                    <b-form-input
                    @keypress="allowOnlyNumbers"
                      v-model="form8.postal_code"
                      :maxlength="6"
                      :class="{ 'is-invalid': $v.form8.postal_code.$error || getBackendError('postal_code') }"
                    />
                    <div v-if="$v.form8.postal_code.$error" class="invalid-feedback">
                      <div v-if="!$v.form8.postal_code.required">Postal code required.</div>
                      <div v-if="!$v.form8.postal_code.numeric">Must be numeric.</div>
                      <div v-if="!$v.form8.postal_code.minLength">Must be 6 digits.</div>
                      <div v-if="!$v.form8.postal_code.maxLength">Must be exactly 6 digits.</div>
                    </div>
                    <div v-if="getBackendError('postal_code')" class="invalid-feedback">
                      {{ getBackendError('postal_code') }}
                    </div>
                    
                  </b-form-group>

                </b-col>
              </b-row>

              <!-- LEGAL INFO -->
              <h5 class="mt-4">Legal Information</h5>
              <b-row>
                <b-col cols="6">
                  <b-form-group>
                    <label for="Account Number"
                      >Account Number <span style="color: red">*</span></label
                    >
                    <b-form-input
                      @keypress="allowOnlyNumbers"
                      v-model="form8.account_number"
                      :class="{ 'is-invalid': $v.form8.account_number.$error || getBackendError('account_number') }"
                    ></b-form-input>

                    <div v-if="$v.form8.account_number.$error" class="invalid-feedback">
                      <div v-if="!$v.form8.account_number.required">Account number is required.</div>
                    </div>

                    <!-- Backend Error -->
                    <div v-if="getBackendError('account_number')" class="invalid-feedback">
                      {{ getBackendError('account_number') }}
                    </div>
                    
                  </b-form-group>
                </b-col>


                <b-col cols="6">
                  <b-form-group>
                    <label for="Beneficiary Name"
                      >Beneficiary Name <span style="color: red">*</span></label
                    >
                    <b-form-input
                      v-model="form8.beneficiary_name"
                      :class="{ 'is-invalid': $v.form8.beneficiary_name.$error || getBackendError('beneficiary_name') }"
                      @blur="$v.form8.beneficiary_name.$touch()"
                    ></b-form-input>

                    <!-- Frontend errors -->
                    <div v-if="$v.form8.beneficiary_name.$error" class="invalid-feedback">
                      <div v-if="!$v.form8.beneficiary_name.required">Beneficiary name is required.</div>
                    </div>

                    <!-- Backend error -->
                    <div v-if="getBackendError('beneficiary_name')" class="invalid-feedback">
                      {{ getBackendError('beneficiary_name') }}
                    </div>
                    
                  </b-form-group>
                </b-col>



                <b-col cols="6">
                  <b-form-group>
                    <label for="IFSC Code"
                      >IFSC Code <span style="color: red">*</span></label
                    >
                    <b-form-input
                      v-model="form8.ifsc_code"
                      @keypress="allowIFSC"
                      @paste="allowIFSCPaste"
                      :class="{ 'is-invalid': $v.form8.ifsc_code.$error || getBackendError('ifsc_code') }"
                      @blur="$v.form8.ifsc_code.$touch()"
                    ></b-form-input>

                    <!-- Frontend errors -->
                    <div v-if="$v.form8.ifsc_code.$error" class="invalid-feedback">
                      <div v-if="!$v.form8.ifsc_code.required">IFSC code is required.</div>
                    </div>

                    <!-- Backend error -->
                    <div v-if="getBackendError('ifsc_code')" class="invalid-feedback">
                      {{ getBackendError('ifsc_code') }}
                    </div>
                    
                  </b-form-group>
                </b-col>


                <!-- Split -->
                <b-col cols="6">
                  <b-form-group>
                    <label for="Split Type"
                      >Split Type <span style="color: red">*</span></label
                    >
                    <b-form-select
                      v-model="form8.split_type"
                      :options="[
                        { value: 'fixed', text: 'Fixed' },
                        { value: 'percentage', text: 'Percentage' }
                      ]"
                      :class="{ 'is-invalid': $v.form8.split_type.$error || getBackendError('split_type') }"
                      @blur="$v.form8.split_type.$touch()"
                    ></b-form-select>

                    <!-- Frontend errors -->
                    <div v-if="$v.form8.split_type.$error" class="invalid-feedback">
                      <div v-if="!$v.form8.split_type.required">Split type is required.</div>
                    </div>

                    <!-- Backend error -->
                    <div v-if="getBackendError('split_type')" class="invalid-feedback">
                      {{ getBackendError('split_type') }}
                    </div>
                    
                  </b-form-group>
                </b-col>


                <b-col cols="6">
                  <b-form-group>
                    <label for="Split Value"
                      >Split Value <span style="color: red">*</span></label
                    >
                    <b-form-input
                      @keypress="allowDecimal"
                      @paste="allowDecimalPaste"
                      v-model="form8.split_value"
                      :class="{ 'is-invalid': $v.form8.split_value.$error || getBackendError('split_value') }"
                      @blur="$v.form8.split_value.$touch()"
                    ></b-form-input>

                    <!-- Frontend errors -->
                    <div v-if="$v.form8.split_value.$error" class="invalid-feedback">
                      <div v-if="!$v.form8.split_value.required">Split value is required.</div>
                    </div>

                    <!-- Backend error -->
                    <div v-if="getBackendError('split_value')" class="invalid-feedback">
                      {{ getBackendError('split_value') }}
                    </div>
                    
                  </b-form-group>
                </b-col>

                <b-col cols="6">
                  <!-- <b-form-group label="PAN">
                    <b-form-input v-model="form8.legal_info.pan"></b-form-input>
                  </b-form-group> -->
                  <b-form-group>
                    <label for="Owner PAN Card Number" 
                      >PAN Card Number <span style="color: red">*</span></label
                    >
                    <b-form-input
                      v-model="form8.owner_pan"
                      :maxlength="10"
                      :class="{ 'is-invalid': $v.form8.owner_pan.$error || getBackendError('pan') }"
                    />
                    <div v-if="$v.form8.owner_pan.$error" class="invalid-feedback">
                      <div v-if="!$v.form8.owner_pan.required">PAN is required.</div>
                      <div v-if="!$v.form8.owner_pan.validPAN">Enter a valid PAN (ABCDE1234F).</div>
                    </div>
                    <div v-if="getBackendError('owner_pan')" class="invalid-feedback">
                      {{ getBackendError('owner_pan') }}
                    </div>
                    
                  </b-form-group>

                </b-col>

                <b-col cols="6" v-if="showBusinessPAN">
                  <b-form-group>
                    <label for="Business PAN Card Number">
                      Business PAN Card Number <span style="color: red">*</span>
                    </label>

                    <b-form-input
                      v-model="form8.business_pan"
                      :maxlength="10"
                      :class="{ 'is-invalid': $v.form8.business_pan.$error || getBackendError('business_pan') }"
                    />

                    <div v-if="$v.form8.business_pan.$error" class="invalid-feedback">
                      <div v-if="!$v.form8.business_pan.required">Business PAN is required.</div>
                      <div v-if="!$v.form8.business_pan.validPAN">Enter a valid PAN (ABCDE1234F).</div>
                    </div>

                    <div v-if="getBackendError('business_pan')" class="invalid-feedback">
                      {{ getBackendError('business_pan') }}
                    </div>
                  </b-form-group>
                </b-col>


                <!-- </b-col> -->

                <b-col cols="6">
                  <!-- <b-form-group label="GST">
                    <b-form-input v-model="form8.legal_info.gst"></b-form-input>
                  </b-form-group> -->
                  <b-form-group label="GST Number">
                    <b-form-input
                      v-model="form8.gst"
                      :class="{ 'is-invalid': $v.form8.gst.$error || getBackendError('gst') }"
                    />
                    <div v-if="$v.form8.gst.$error" class="invalid-feedback">
                      Invalid GSTIN format.
                    </div>
                    <div v-if="getBackendError('gst')" class="invalid-feedback">
                      {{ getBackendError('gst') }}
                    </div>
                    
                  </b-form-group>

                </b-col>
              </b-row>

              <div class="col-12">
                <b-button type="submit" variant="primary" class="mr-2" style="margin-bottom:20px;">
                  Save Data
                </b-button>

              </div>

            </b-form>

          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import MixinRequest from "../../../mixins/request";
import member_mixin from "../../../mixins/ModuleJs/member-list";
// import Multiselect from "vue-multiselect";
import { required, email, numeric, minLength, maxLength, helpers, requiredIf } from "vuelidate/lib/validators";
import moment from "moment";
import { members } from "../../../js/path";
export default {
  data() {
    return {
      store: false,
      title: "Edit Member",
      message: "",
      messages: [],
    };
  },
  mixins: [MixinRequest, member_mixin],
  components: {
    Layout,
    // Multiselect,
  },
  validations: {
    form8: {
      email: { required, email },

      phone: { required, numeric, minLength: minLength(8), maxLength: maxLength(15) },

      legal_business_name: { required, minLength: minLength(4), maxLength: maxLength(200) },

      customer_facing_business_name: { minLength: minLength(1), maxLength: maxLength(255) },

      contact_name: { required, minLength: minLength(1), maxLength: maxLength(255) },

      business_type: { required },

      reference_id: { minLength: minLength(1), maxLength: maxLength(512) },

        category: { required },
        subcategory: { required },
        business_model: { minLength: minLength(1), maxLength: maxLength(255) },

            street1: { required, maxLength: maxLength(100) },
            street2: { required, maxLength: maxLength(100) },
            city: { required, maxLength: maxLength(100),onlyText: helpers.regex("onlyText", /^[A-Za-z\s]+$/) },
            state: { required, minLength: minLength(2), maxLength: maxLength(32) },
            postal_code: { required, numeric, minLength: minLength(6), maxLength: maxLength(6) },
            country: { minLength: minLength(2), maxLength: maxLength(64) },

        owner_pan: {
          required,
          validPAN(value) {
            if (!value) return false;
            return /^[A-Za-z]{5}\d{4}[A-Za-z]{1}$/.test(value);
          }
        },
        gst: {
          validGST(value) {
            if (!value) return true;
            return /^[0-3][0-9][a-z]{5}[0-9]{4}[a-z][0-9][a-z0-9][a-z0-9]$/i.test(value);
          }
        },
        account_number: { required },
        beneficiary_name: { required },
        ifsc_code: { required },
        split_type: { required },
        split_value: { required },
        business_pan: {
          required: requiredIf(function () {
            const t = this.form8.business_type;
            return t !== "individual" && t !== "proprietorship" &&  t !== "not_yet_registered"  && t !== "educational_institutes";
          }),
          validPAN(value) {
            if (!value) return true;
            return /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value);
          }
        }

    }

  },
  methods: {
    disabledDates() {
      return new Date().toISOString().slice(0, 16);
    },
    sendInfoNote(val) {
      this.id = val;
      this.fetchNotes(this.id);
    },
    getSessionStart: function (session_time) {
      let dateTime1 = moment(session_time).format("LLLL");
      return dateTime1;
    },
    async fetchNotes(val) {
      const url = members.fetchNotes + val;
      const data = await this.getRequest(url);
      console.log(data);
      this.messages = data.response;
    },

    async storeNotes(val, message) {
      this.message = "";
      try {
        const url = members.storeNotes;
        let dataAppend = new FormData();
        dataAppend.append("member_id", val);
        dataAppend.append("notes", message);
        const data = await this.postRequest(url, dataAppend);
        if (data.status) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "success",
            title: data.message,
          });
        }
        // this.isClickedMciReferrel = false;
        this.fetchNotes(this.$route.params.id);
      } catch (err) {
        console.log(err);
      }
    },
    renderClickableLink(message) {
      const clickableText = message.replace(
        /(https?:\/\/[^\s]+)/g,
        '<a href="$1" target="_blank">$1</a>'
      );
      return clickableText;
    },
  },
};
</script>